function initContentPath() {
  if (window.ecologyContentPath) {
    // 添加二级路径给 img
    const e9HooksOld = {
      ...window.e9Hooks
    };
    window.e9Hooks = {
      ...window.e9Hooks,
      reactDOMSetInnerHTML: (node, html) => {
        let newHtml = `${html}`;
        if (typeof e9HooksOld.reactDOMSetInnerHTML === "function") {
          newHtml = e9HooksOld.reactDOMSetInnerHTML(node, html) || `${html}`;
        }
        const imgReg = /<(img|a|iframe)\s[^>]+\/?>/gi;
        let match = newHtml.match(imgReg);
        if (match && match.length) {
          const srcReg = /(src|href)=[\'\"]?([^\'\"]*)[\'\"]?\s/i;
          newHtml = newHtml.replace(imgReg, () => "{~}");
          match.forEach(m => {
            m = m.replace(imgReg, img => {
              const srcMatch = img.match(srcReg);
              if (srcMatch && srcMatch.length) {
                var src = srcMatch[2];
                src.replace(/\s$/, "");
                const reg = new RegExp(`^${window.ecologyContentPath}`);
                if (src && !reg.test(src) && /^\//.test(src)) {
                  return img.replace(
                    srcReg,
                    () =>
                      `${/^src/.test(srcMatch[0]) ? "src" : "href"}="${
                        window.ecologyContentPath
                      }${src}"`
                  );
                }
              }
              return img;
            });
            newHtml = newHtml.replace(/{~}/, () => m);
          });
          node.innerHTML = newHtml;
        } else {
          // default
          node.innerHTML = newHtml;
        }
        return newHtml;
      },
      reactDOMSetAttribute: (
        isCustomComponentTag,
        propertyInfo,
        node,
        attributeName,
        attributeValue,
        attributeNamespace
      ) => {
        let newAttributeValue = attributeValue;
        if (typeof e9HooksOld.reactDOMSetAttribute === "function") {
          newAttributeValue = e9HooksOld.reactDOMSetAttribute(
            isCustomComponentTag,
            propertyInfo,
            node,
            attributeName,
            attributeValue,
            attributeNamespace
          );
        }
        if (
          window.ecologyContentPath &&
          ((node.nodeName === "IMG" && attributeName === "src") ||
            (node.nodeName === "IFRAME" && attributeName === "src") ||
            (node.nodeName === "A" && attributeName === "href"))
        ) {
          const reg = new RegExp(`^${window.ecologyContentPath}`);
          if (!reg.test(newAttributeValue) && /^\//.test(newAttributeValue)) {
            newAttributeValue = window.ecologyContentPath + newAttributeValue;
          }
        }
        // default
        if (isCustomComponentTag || propertyInfo === null) {
          node.setAttribute(attributeName, newAttributeValue);
          return newAttributeValue;
        }
        if (propertyInfo.mustUseProperty) {
          node[attributeName] = newAttributeValue;
          return newAttributeValue;
        }
        if (attributeNamespace) {
          node.setAttributeNS(
            attributeNamespace,
            attributeName,
            newAttributeValue
          );
          return newAttributeValue;
        } else {
          node.setAttribute(attributeName, newAttributeValue);
          return newAttributeValue;
        }
      }
    };
  }
}
module.exports = initContentPath;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/contentPath.js